import {useEffect, useRef, useState} from 'react';
import ClearIcon from '@mui/icons-material/Close';
import {IconButton, TextField} from '@mui/material';

type Props = {
  value?: string;
  onChange: (value: string | undefined) => void;
};

export const SearchFilter = ({value, onChange}: Props) => {
  const [input, setInput] = useState(value ?? '');

  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  const timerRef = useRef<any>(null);

  useEffect(() => {
    if (input === '') return;

    const t = setTimeout(() => {
      onChangeRef.current(input.trim());
    }, 550);

    timerRef.current = t;
    return () => clearTimeout(t);
  }, [input]);

  const clear = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setInput('');
    onChangeRef.current('');
  };

  return (
    <TextField
      size="small"
      placeholder="Search"
      value={input}
      onChange={e => {
        const next = e.target.value;

        setInput(next);

        if (next === '') {
          if (timerRef.current) {
            clearTimeout(timerRef.current);
          }
          onChangeRef.current('');
        }
      }}
      sx={{
        '& .MuiInputBase-root': {
          height: 40,
          flexGrow: 1,
          minWidth: 220,
          width: 440,
        },
      }}
      InputProps={{
        endAdornment: input && (
          <IconButton size="small" onClick={clear} sx={{width: 14, height: 14}}>
            <ClearIcon fontSize="small" />
          </IconButton>
        ),
      }}
    />
  );
};
